import { FC } from 'react';
import { Typography, Box } from 'components';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';

export interface BaseErrorProps {
    iconUrl: string;
    keyLarge: string;
    keySmall: string;
    errorCode?: number;
}

const StyledImage = styled.img`
    margin: auto;
    display: block;
    maxwidth: 100%;
    maxheight: 100%;
`;

export const BaseError: FC<BaseErrorProps> = ({
    iconUrl,
    keyLarge,
    keySmall,
    errorCode
}) => {
    const { t } = useTranslation();

    return (
        <Box
            display="flex"
            flexDirection="column"
            justifyContent="center"
            alignItems="center"
            width="100%"
            height="100%">
            <Box width="120px" height="120px" mb="40px">
                <StyledImage alt="iconUrl" src={iconUrl} />
            </Box>
            <Box>
                <Typography variant="h6">
                    <Box component="span">{t(keyLarge)} </Box>
                    {errorCode && (
                        <Box fontWeight="bold" component="span">
                            {errorCode}
                        </Box>
                    )}
                </Typography>
            </Box>
            <Box>
                <Typography variant="caption">
                    <Box
                        display="flex"
                        flexDirection="column"
                        justifyContent="center"
                        alignItems="center">
                        <Box>{t(keySmall)}</Box>
                    </Box>
                </Typography>
            </Box>
        </Box>
    );
};
